import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { Details } from "../../services/medicine.services";
import Breadcrums from "../../common/breadcrumbs";

const MedicineView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Medicine Management"),
      url: "/admin/medicine-management/medicine/list/1",
    },
    { title: t("admin.cafes.link_view"), url: "" },
  ];


  useEffect(() => {
    Details(params.id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("View Medicine")}</h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? <div className='row'>
                <div className="col-lg-12 form-group">
                  <table id="simple-table" className="table  table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th>{t("Medicine Name")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.name
                            ? showdefault.name
                            : "N/A"}
                        </td>
                      </tr>

                      <tr>
                        <th>{t("Medicine ID")}</th>
                        <td className="text-capitalize">
                          {showdefault && showdefault.medicine_id
                            ? showdefault.medicine_id
                            : "N/A"}
                        </td>
                      </tr>

                      {/* <tr>
                        <th>{t("Quantity")}</th>
                        <td>
                          {showdefault && showdefault.quantity
                            ? showdefault.quantity
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Expiry Date")}</th>
                        <td>
                          {showdefault && showdefault.expiry_date
                            ? formateDate(showdefault.expiry_date)
                            : "N/A"}
                        </td>
                      </tr> */}
                      <tr>
                        <th>{t("Created Date")}</th>
                        <td>
                          {showdefault && showdefault.createdAt
                            ? formateDate(showdefault.createdAt)
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>{t("Description")}</th>
                        <td>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                showdefault && showdefault?.description
                                  ? showdefault.description
                                  : "N/A",
                            }}
                          ></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <h6 className="main-content-label mb-3">{t("Description")}:</h6>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        showdefault && showdefault?.description
                          ? showdefault.description
                          : "N/A",
                    }}
                  ></div> */}
                  <div className="mt-5">
                    <button className="btn ripple btn-dark" type='button' onClick={() => navigate(-1)}>
                      <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                      {t("admin.button.btn_back")}
                    </button>
                  </div>
                </div>
              </div> : <Loader />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MedicineView;
